"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Bar, BarChart, Line, LineChart, ResponsiveContainer } from "recharts";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ChartContainer } from "@/components/ui/chart";
const leftChartData = [{
  value: 20
}, {
  value: 45
}, {
  value: 30
}, {
  value: 65
}, {
  value: 40
}, {
  value: 80
}, {
  value: 55
}, {
  value: 90
}, {
  value: 70
}, {
  value: 100
}];
const rightChartData = [{
  value: 15
}, {
  value: 35
}, {
  value: 25
}, {
  value: 55
}, {
  value: 45
}, {
  value: 75
}, {
  value: 60
}, {
  value: 85
}, {
  value: 70
}, {
  value: 95
}];
const chartConfig = {
  value: {
    color: "var(--primary)"
  }
};
export default function ReadyForADataBackedStrategy() {
  return <section data-section-id="229891" id="bereit-für-den-sicherheits-check" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-primary/5 pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/20 via-background/0 to-background/0 pointer-events-none" />

      {}
      <div className="absolute left-[-20%] md:left-[-10%] top-1/2 -translate-y-1/2 w-[60%] md:w-[40%] h-[120%] opacity-5 md:opacity-10 pointer-events-none blur-[2px] -rotate-6" aria-hidden="true">
        <ChartContainer config={chartConfig} className="w-full h-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={leftChartData}>
              <Bar dataKey="value" fill="var(--color-value)" radius={[2, 2, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </div>

      {}
      <div className="absolute right-[-20%] md:right-[-10%] top-1/2 -translate-y-1/2 w-[60%] md:w-[40%] h-[120%] opacity-5 md:opacity-10 pointer-events-none blur-[2px] rotate-6" aria-hidden="true">
        <ChartContainer config={chartConfig} className="w-full h-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={rightChartData}>
              <Line type="monotone" dataKey="value" stroke="var(--color-value)" strokeWidth={4} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </ChartContainer>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-default text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl text-foreground">
            Bereit für den Sicherheits-Check?
          </h2>
          
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground md:text-xl font-sans">
            Schützen Sie Ihre digitale Infrastruktur mit einer umfassenden Analyse. Wir identifizieren Schwachstellen, bevor sie zum Risiko für Ihr Unternehmen werden.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-default rounded-sm shadow-lg shadow-primary/20" asChild>
              <Link to="/ContactPage">
                Jetzt Audit anfordern
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 text-base font-default rounded-sm border-primary/30 hover:bg-primary/5 backdrop-blur-md" asChild>
              <Link to="/SecuritySolutionsPage">
                Unsere Lösungen
              </Link>
            </Button>
          </div>
        </div>
      </div>
      
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[linear-gradient(to_bottom,transparent_0%,#fff_50%,transparent_100%)] bg-[length:100%_4px] animate-[pulse_4s_infinite]" />
    </section>;
}